import React, {useEffect} from 'react';
import { Modal } from 'antd';
import {useTranslation} from "react-i18next";

export type JModalProps = {

    /**
     * Action to update external module
     * @param value
     */
    handleOk?: (value: any) => void;

    /**
     * Action to update external module
     * @param value
     */
    handleCancel?: (value: any) => void;

    /**
     * Default values
     */
    isModalVisible: boolean;

    /**
     * Children
     */
    children?: JSX.Element | JSX.Element[];

    /**
     * footer
     */
    footer?: JSX.Element | JSX.Element[] | null;

    /**
     * title
     */
    title?: string;

    /**
     * style
     */
    style?: any;

    /**
     * className
     */
    className?: any;

    /**
     * width
     */
    width?: number;
};



/**
 * Blocco di scelta frequenza
 * @constructor
 */
export const JModal = ({
                           style,
                           isModalVisible,
                           handleOk,
                           handleCancel,
                           children,
                           footer,
                           title,
                           width,
                           className
                       }: JModalProps) => {

    const { t: translate } = useTranslation();


    useEffect(() => {
        let btn: HTMLCollectionOf<Element> = document.getElementsByClassName('ant-modal-close')
        if(btn.length > 0){
            [].forEach.call(btn, function (el: Element) {
                el.ariaLabel =  translate('CLOSE')
            });

        }
        let span = document.getElementsByClassName('ant-modal-close-icon')
        if(span.length > 0){
            [].forEach.call(span, function (el: Element) {
                el.ariaLabel =  translate('CLOSE')
            });
        }
    });


    return (
        <Modal
            className={className}
            width={width}
            style={style}
            title={title}
            open={isModalVisible}
            onOk={handleOk}
            onCancel={handleCancel}
            footer={footer}>
            {children}
        </Modal>
    );
};
